// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7155":"b5a39e40","7235":"eaa1432c","9237":"b5a39e40"}[chunkId] + ".chunk.css";
};